import { FC } from "react";
import "./TaskAddEditForm.css";
import { IOptionsQueryParams } from "../../../helpers/paramsAutoFiller";
import TaskAddEditFormProvider from "./TaskAddEditFormProvider";
import TaskFormMain from "./FormComponents/TaskFormMain";
export interface ITaskAddEditFormProps {
    mode: "create" | "edit";
    optionsQueryParams: IOptionsQueryParams;
    taskId: number | undefined;
    closeFunc: () => void;
    columnId?: number;
    defaultBoardId?: number; // Если вызываем с доски, то передается этот идентификатор
    onTaskAction?: () => void;
    projectId?: number;
    permission?: boolean;
    responsibleRequired: boolean;
    parentTaskId?: number;
}


const TaskAddEditForm: FC<ITaskAddEditFormProps> = ({
    mode,
    taskId,
    closeFunc,
    columnId,
    onTaskAction,
    projectId,
    permission,
    parentTaskId,
    optionsQueryParams,
    responsibleRequired,
    defaultBoardId
}) => {

    return (
        <TaskAddEditFormProvider 
            mode = {mode}
            taskId = {taskId}
            closeFunc = {closeFunc}
            columnId = {columnId}
            onTaskAction = {onTaskAction}
            projectId = {projectId}
            permission = {permission}
            parentTaskId = {parentTaskId}
            optionsQueryParams = {optionsQueryParams}
            responsibleRequired = {responsibleRequired}
            defaultBoardId={defaultBoardId}
        >
            <TaskFormMain/>
        </TaskAddEditFormProvider>
    );
};

export default TaskAddEditForm;
